/**
 * Renders a toast element
 * @property {string} id - The ID attribute for the tooltip element
 * @property {string} content - The tooltip content
 */

import React from 'react';

// Icons
import * as icons from '../ui/Icons';

// Components
import Button from './Button';

const Toast = class Toast extends React.Component {
  render() {
    const { closeToast, toast, toastType } = this.props.store.AppStore;

    return (
      <aside
        className={`toast${
          toastType ? ` toast--${toastType}` : ''
        }`}
      >
        <i className="toast__icon">
          {!toastType &&
            <icons.infoCircle />
          }

          {toastType === 'positive' &&
            <icons.checkCircle />
          }

          {toastType === 'warn' &&
            <icons.warningCircle />
          }

          {toastType === 'negative' &&
            <icons.minusCircle />
          }
        </i>

        <span className="toast__content">
          {toast}
        </span>

        <Button
          className="toast__close"
          onClick={() => closeToast()}
        >
          <icons.times />

          <span className="meta">
            Dismiss
          </span>
        </Button>
      </aside>
    )
  }
}

export default Toast;
